import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'llm',
  version: '1.0.0',
  properties: [
    {
      key: 'provider',
      label: 'Provider',
      type: 'options',
      required: true,
      default: 'openai',
      options: [
        { value: 'openai', name: 'OpenAI' },
        { value: 'anthropic', name: 'Anthropic' },
        { value: 'azure', name: 'Azure OpenAI' },
      ],
    },
    {
      key: 'credentialId',
      label: 'API Credential',
      type: 'string',
      required: true,
      typeOptions: {
        credentialType: '={{$parameter["provider"]}}',
      },
    },
    {
      key: 'model',
      label: 'Model',
      type: 'string',
      required: true,
      default: 'gpt-4',
      placeholder: 'gpt-4',
    },
    {
      key: 'prompt',
      label: 'Prompt',
      type: 'string',
      required: true,
      typeOptions: {
        rows: 6,
      },
      placeholder: 'Enter your prompt here...',
    },
    {
      key: 'temperature',
      label: 'Temperature',
      type: 'number',
      default: 0.7,
      typeOptions: {
        minValue: 0,
        maxValue: 2,
        numberPrecision: 1,
      },
    },
    {
      key: 'maxTokens',
      label: 'Max Tokens',
      type: 'number',
      default: 1024,
      typeOptions: {
        minValue: 1,
        maxValue: 4096,
      },
    },
  ],
};

export default schema;
